<template>
  <div class="content">
    <div class="content_title">
      Аккаунты Парсек
    </div>
    <div class="content_row" v-show="!parsecAccounts.length">
      <div>
        <label>Логин: <input v-model="login"/></label>
      </div>
      <div>
        <label>Пароль: <input v-model="password"/></label>
      </div>
      <div>
        <label>IP: <input v-model="server_ip"/></label>
      </div>
      <div>
        <button @click="addParsecAccount">Отправить</button>
      </div>
    </div>
    <div
      class="content_row"
      v-for="(parsecAccount, key) in parsecAccounts"
      :key="key"
    >
      <div>
        {{ parsecAccount.LOGIN }}
      </div>
      <div>
        {{ parsecAccount.PASSWORD }}
      </div>
      <div>
        {{ parsecAccount.SERVER_IP }}
      </div>
      <div>
        <button @click="deleteParsecAccount(parsecAccount.ID)">
          Удалить аккаунт
        </button>
      </div>
    </div>
    <parsec-access-link
      v-show="showLink"
      v-on:groups-updated="updateTypes"
    ></parsec-access-link>
    <parsec-access-types-link ref="types_link"></parsec-access-types-link>
  </div>
</template>

<script>
import ParsecAccessLink from "components/backoffice/parsec/ParsecAccessLink";
import ParsecAccessTypesLink from "components/backoffice/parsec/ParsecAccessTypesLink";
import config from "@/config";

export default {
  name: "GetParsecAccounts",
  props: {
    updateList: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ParsecAccessLink,
    ParsecAccessTypesLink
  },
  data() {
    return {
      url: config.backend_url,
      detailUrl: "",
      parsecAccounts: [],
      showLink: true,
      login: "",
      password: "",
      server_ip: ""
    };
  },
  computed: {},
  watch: {
    updateList: function(state) {
      if (state) {
        this.getParsecAccounts();
      }
    }
  },
  methods: {
    getParsecAccounts: function() {
      let self = this;
      let user = this.$store.getters["user/getProfile"];
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "parsecaccounts/get/",
          filter: { AGREEMENT: user.id },
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.parsecAccounts = data;
          }
        });
    },
    addParsecAccount: function() {
      let self = this;
      let user = this.$store.getters["user/getProfile"];
      let newAccount = {
        LOGIN: self.login,
        PASSWORD: self.password,
        SERVER_IP: self.server_ip,
        AGREEMENT: user.id
      };
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "parsecaccounts/add/",
          data: newAccount,
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          self.getParsecAccounts();
        });
    },
    deleteParsecAccount: function(account_id) {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "parsecaccounts/delete/",
          data: { ID: account_id },
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          self.getParsecAccounts();
        });
    },
    updateTypes: function() {
      this.$refs.types_link.getGroupsData();
    }
  },
  created() {
    this.getParsecAccounts();
    this.detailUrl = this.$route.fullPath;
  }
};
</script>
